import OnePlatformCommonActions from "@frameworks/web/redux/actions/common/commonActions";
import { TAX_REPORT_DATA, TAX_SUMMARIZE, } from "@frameworks/web/redux/interfaces/Reports/CoreReports/iTaxReport";
class TaxActions extends OnePlatformCommonActions {
    getTaxReport(tax, type) {
        this.dispatch({
            type: TAX_REPORT_DATA,
            payload: { tax },
            reducerName: type,
        });
    }
    taxSummarize(summarize, type) {
        this.dispatch({
            type: TAX_SUMMARIZE,
            payload: { summarize },
            reducerName: type,
        });
    }
}
export default TaxActions;
